const updates = [
  { id: 1, time: '07-29 14:32', title: '某女星被拍到深夜出入整形医院，经纪人回应称"例行体检"', tag: '最新' },
  { id: 2, time: '07-29 11:15', title: '知名导演被曝片场辱骂演员，剧组内部人士证实确有此事', tag: '跟进' },
  { id: 3, time: '07-29 09:08', title: '两大直播平台头部主播互怼升级，双方粉丝已开始大规模互扒黑料', tag: '火爆' },
  { id: 4, time: '07-28 22:45', title: '选秀节目出道组成员被举报学历造假，官方表示正在核实', tag: '新料' },
  { id: 5, time: '07-28 18:30', title: '某综艺节目选手私下收到节目组"剧本"，拒绝后被雪藏', tag: '独家' },
  { id: 6, time: '07-28 15:12', title: '娱乐圈资深经纪人发文炮轰行业潜规则，多位艺人转发支持', tag: '热议' },
  { id: 7, time: '07-28 10:56', title: '某男团队长被前女友曝出恋爱期间出轨证据，粉丝后援会集体脱粉', tag: '重磅' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">最新爆料快讯</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">911吃瓜最新资讯实时更新，不错过每一个精彩爆料</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-[2px] bg-primary-200/60 hidden md:block"></div>
          <div className="space-y-1">
            {updates.map((item) => (
              <div key={item.id} className="group flex items-start gap-4 py-3 px-4 rounded-lg hover:bg-background-50 transition-colors cursor-pointer">
                <div className="relative z-10 hidden md:flex items-center justify-center shrink-0 mt-1">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 group-hover:scale-125 transition-transform"></div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 flex-1 min-w-0">
                  <span className={`shrink-0 px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${
                    item.tag === '最新' || item.tag === '重磅' || item.tag === '火爆'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '独家' ? 'bg-accent-100 text-accent-800'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                  <p className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors flex-1 leading-relaxed">
                    {item.title}
                  </p>
                  <span className="text-xs text-foreground-500 whitespace-nowrap shrink-0">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}